// packages/api/src/axios-client.ts
import axios from 'axios'

const baseURL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:5001'

export const axiosClient = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  // ✅ مهم: برای ارسال کوکی‌ها
  withCredentials: true
})

// ✅ Request interceptor برای اضافه کردن token از cookie
axiosClient.interceptors.request.use(
  (config) => {
    // در سمت server کوکی‌ها از request می‌آید
    if (typeof window === 'undefined') {
      // Server-side: نیاز به cookie header دارد
      console.log('🔧 [axiosClient] Server-side request')
    } else {
      // Client-side: مرورگر خودش کوکی‌ها رو می‌فرسته
      console.log('🔧 [axiosClient] Client-side request')
    }
    return config
  },
  (error) => {
    console.error('❌ [axiosClient] Request error:', error)
    return Promise.reject(error)
  }
)

// ✅ Response interceptor برای هندل کردن خطاها
axiosClient.interceptors.response.use(
  (response) => {
    console.log('✅ [axiosClient] Response success:', response.config.url)
    return response
  },
  (error) => {
    console.error('❌ [axiosClient] Response error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message
    })

    // اگر 401 بود، یعنی unauthorized
    if (error.response?.status === 401) {
      console.error('🔒 [axiosClient] Unauthorized - token invalid or expired')
    }

    return Promise.reject(error)
  }
)

export default axiosClient